"use client";

import dynamic from "next/dynamic";

const CookieConsentManager = dynamic(
  () => import("@/components/cookie-consent-manager").then((mod) => mod.CookieConsentManager),
  { ssr: false },
);

const AnimatedSpectrumProvider = dynamic(
  () => import("@/components/animated-spectrum-provider").then((mod) => mod.AnimatedSpectrumProvider),
  { ssr: false },
);

export function RootClientEnhancements() {
  return (
    <>
      <CookieConsentManager />
      <AnimatedSpectrumProvider />
    </>
  );
}
